import script from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackForm.vue?vue&type=style&index=0&id=79460828&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79460828"]])

export default __exports__